module.exports = lvflanders.bar.ng.core;